import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';

// Expenses screens
import { ExpensesIntroScreen } from '../../screens/tasks/expenses/ExpensesIntroScreen';
import { ExpensesDashboardScreen } from '../../screens/tasks/expenses/ExpensesDashboardScreen';
import { ExpensesDataScreen } from '../../screens/tasks/expenses/ExpensesDataScreen';
import { ExpensesInputScreen } from '../../screens/tasks/expenses/ExpensesInputScreen';

const Stack = createNativeStackNavigator();

const ExpensesStackNavigator: React.FC = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
      }}
    >
      <Stack.Screen name="ExpensesIntroScreen" component={ExpensesIntroScreen} />
      <Stack.Screen name="ExpensesDashboardScreen" component={ExpensesDashboardScreen} />
      <Stack.Screen name="ExpensesDataScreen" component={ExpensesDataScreen} />
      <Stack.Screen name="ExpensesInputScreen" component={ExpensesInputScreen} />
    </Stack.Navigator>
  );
};

export default ExpensesStackNavigator;